// extracted by mini-css-extract-plugin
export var container = "features-page-template-module--container--3T1zp";
export var slopeBegin = "features-page-template-module--slopeBegin--59ptc";
export var slopeEnd = "features-page-template-module--slopeEnd--1CZ98";